


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { IHomeStatistic } from '@/store/modules/home/types/IHomeStatistics';

@Component
export default class Statistics extends Vue {
  @Prop({ type: String, required: true }) private title!: string;
  @Prop({ type: String, required: false }) private subtitle!: string;
  @Prop({ type: Array, required: true }) private types!: IHomeStatistic[];
}
